import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PreviewDocumentService {
  constructor(private readonly httpClient: HttpClient) {}

  getPackagePreview(PackageUserGuid: string) {
    return this.httpClient.get(`docs/preview/packageUsers/${PackageUserGuid}`, {
      responseType: 'blob',
    });
  }
}
